import { render, staticRenderFns } from "./EventListLink.vue?vue&type=template&id=2a622e13&scoped=true"
import script from "./EventListLink.vue?vue&type=script&lang=js"
export * from "./EventListLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a622e13",
  null
  
)

export default component.exports